import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';

const codesData = [
    {
    title: 'Recueil des concepts, définitions, nomenclatures et méthodologies utilisées dans le système statistique national du Burundi, Deuxième édition, 2024',
    principalLink: "/documents/Codes/Recueil_concepts_definitions_nomenclatures_SSN_Burundi_VF_05_12_2024.pdf",
    image: 'assets/Codes/code_bonne_pratique.PNG',
    description: "Une référentiel officiel qui standardise les concepts, définitions, nomenclatures et méthodes de production des statistiques officielles pour garantir leur cohérence et leur qualité à l'échelle nationale",
    publicationDate: "2025-09-15"
  },
    {
        title: 'Recueil des concepts, définitions, nomenclatures et méthodologies utilisées dans le système statistique national du Burundi, première édition, 2024',
    principalLink: '/documents/Bulletins/Recueil-.pdf',
    image: 'assets/Codes/code_bonne_pratique.PNG',
    description: "La présentation de nouveaux concepts et méthodologies.",
    publicationDate: "2024-11-15"
  },
  
  {
    title: "Code de Bonne Pratique de la Statistique",
    principalLink: "/documents/Codes/Code-de-bonnes-pratiques-de-la-statistique-dans-le-système-statistique-national-du-Burundi-1.pdf",
    image: 'assets/Codes/code_bonne_pratique.PNG',
    description: "Guide définissant les normes à respecter pour garantir la fiabilité des statistiques produites au Burundi.",
    publicationDate: "2016-12-15"
  },
  {
    title: "Lignes Directrices sur la Qualité de Production de la Statistique",
    principalLink: "/documents/Codes/Lignes_Directrices_Qualite.pdf",
    image: 'assets/Codes/lignes_directrices.PNG',
    description: "Directives assurant la qualité du processus de production statistique.",
    publicationDate: "2016-11-15"
  },
  {
    title: "Stratégie pour Harmoniser les Statistiques en Afrique",
    principalLink: "/documents/Codes/Strategie_Harmonisation_Afrique.pdf",
    image: 'assets/Codes/strategie_harmonisation.PNG',
    description: "Plan visant à promouvoir la coopération entre pays africains pour des pratiques statistiques comparables.",
    publicationDate: "2023-01-15"
  },
];

function PageCodes() {
  const [visibleCount, setVisibleCount] = useState(3);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredCodes, setFilteredCodes] = useState(codesData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 3);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    let filtered;

    if (year === 'Tous') {
      filtered = codesData;
    } else {
      filtered = codesData.filter((code) => new Date(code.publicationDate).getFullYear() === parseInt(year));
    }

   
    filtered.sort((a, b) => new Date(b.publicationDate) - new Date(a.publicationDate));
    setFilteredCodes(filtered);
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Codes du Système Statistique National (SSN)
          </Typography>
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Le Système Statistique National (SSN) est essentiel pour le développement économique du Burundi en garantissant des données fiables pour des décisions éclairées.
          </Typography>

          <FormControl fullWidth variant="outlined"style={{ marginLeft: '0px', width: '300px', marginBottom:'20px' }}>
            <InputLabel id="year-select-label">Sélectionnez par l'année</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionnez par l'année"
            >
              <MenuItem value="Tous">Tous les documents</MenuItem>
              {[...new Set(codesData.map((code) => new Date(code.publicationDate).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          <Grid container spacing={2}>
            {filteredCodes.slice(0, visibleCount).map((code, index) => (
              <Grid item xs={12} sm={6} md={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a href={code.principalLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                      <CardMedia component="img" sx={{ width: 71, height: 100, m: 2 }} image={code.image} alt={code.title} />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                        <a href={code.principalLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                        {<DownloadIcon />}{code.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {code.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié le {moment(code.publicationDate).format('DD MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredCodes.length && (
            <Button onClick={handleShowMore} style={{ marginTop: '20px', backgroundColor: theme.palette.primary.main, color: 'white' }}>
              Plus de Documents
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default PageCodes;